import { useState, useContext } from 'react';
import { HeaderContext } from '@contexts/HeaderContext';

const transformLanguage = (sportData) => {
    const [state] = useContext(HeaderContext);
    const enContext = {
        League: sportData.LeagueEn || sportData.CompetitionName,
        HomeTeam: sportData.HomeTeam.NameEn || sportData.HomeTeam.Name,
        AwayTeam: sportData.AwayTeam.NameEn || sportData.AwayTeam.Name,
    };
    const zhContext = {
        League: sportData.LeagueZh || sportData.LeagueCn || sportData.CompetitionName,
        HomeTeam: sportData.HomeTeam.NameZh || sportData.HomeTeam.NameCn || sportData.HomeTeam.Name,
        AwayTeam: sportData.AwayTeam.NameZh || sportData.AwayTeam.NameCn || sportData.AwayTeam.Name,
    };
    const languageContext = {
        en: enContext,
        ch: zhContext,
        jp: enContext,
        vn: enContext,
        mm: enContext,
    }[state.language];

    return { languageContext };
};

export default transformLanguage;
